import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import esMessages from 'devextreme/localization/messages/es.json';
import { locale, loadMessages } from 'devextreme/localization';
import "devexpress-richedit/localization/dx-rich.es.js"
import "vueperslides/dist/vueperslides.css";
import "@mdi/font/css/materialdesignicons.css"
import "devexpress-richedit/dist/dx.richedit.css"
//import "../node_modules/devexpress-richedit/dist/dx.richedit.css";

//import 'devextreme/dist/css/dx.common.css';
//import 'devextreme/dist/css/dx.dark.css';
//import 'devextreme/dist/css/dx.light.css';

Vue.config.productionTip = false

loadMessages(esMessages);
locale(navigator.language)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

